import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

import moment from 'moment';

export default {
	getMdjMStastic: ({ searchParams }) => {
		let queryStr = objectToQuerystring({
			partType: searchParams.partType, 
			searchDate: searchParams.searchDate
		});
		return client
			.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/mdjMStatistic` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	getMdjMList: ({ searchParams }) => {
		let queryStr = objectToQuerystring({
			partType: searchParams.partType, 
			searchDate: searchParams.searchDate,
			currentPage: searchParams.currentPage,
			pageUnit: searchParams.pageUnit
		});
		//console.log('searchParams: ', searchParams, ' queryStr: ', queryStr);
		return client
			.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/mdjMList` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
	postSearchColList: () => {
		return client
			.get(`${BASE_URL}/pqy/pcku/mdjRslt/v1/getMdjStatisticCommCode`)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	},
};
